/**
 * @fileoverview
 * Utility functions related to localization specific to the GUI
 */

import {
    languages as indianLanguages,
    isRtl as indianIsRtl,
    supportedLocales as indianSupportedLocales
} from 'indian-l10n';

const wideLocales = [
    'ab',
    'ca',
    'de',
    'el',
    'it',
    'ja',
    'ja-Hira',
    'ko',
    'hu',
    'ru',
    'vi'
];

/**
 * Identify the languages where translations are too long to fit in fixed width parts of the gui.
 * @param {string} locale The current locale.
 * @return {bool} true if translations in this language are too long
 */

const isWideLocale = locale => (
    wideLocales.indexOf(locale) !== -1
);

const unwantedLocales = ['sa', 'ne', 'kok', 'mai', 'ks', 'sd', 'brx', 'doi', 'mni', 'sat'];

const localeMetadata = indianSupportedLocales;
const mergedMessagesByLocale = indianLanguages;
const enabledLocales = ['en', 'or', 'ta']; //  'hi','ur', 'bn', 'gu', 'pa', 'te', 'kn', 'ml'
const supportedLocaleCodes = Object.keys(indianSupportedLocales).filter(
    code => !unwantedLocales.includes(code) && enabledLocales.includes(code)
);
const isRtlLocale = locale => indianIsRtl(locale);

const getLocaleDisplayName = locale => {
    const localeInfo = localeMetadata[locale];
    if (!localeInfo) return locale;
    return localeInfo.nativeName || localeInfo.name || locale;
};

export {
    getLocaleDisplayName,
    isRtlLocale,
    wideLocales,
    isWideLocale,
    localeMetadata,
    mergedMessagesByLocale,
    supportedLocaleCodes
};
